const PbxxRecord = require('../../pbxx_record')

module.exports = class PulseEngagement extends PbxxRecord {
  static get class_name() {
    return 'PulseEngagement'
  }
}
